/*
 * @Author: 刘恩坤 2889356275@qq.com
 * @Date: 2024-07-05 10:21:34
 * @LastEditors: 刘恩坤 2889356275@qq.com
 * @LastEditTime: 2024-07-09 10:20:43
 * @FilePath: \HTML和CSSd:\MCI-50\workstation\src\plugins\element.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue'
import Element from 'element-ui'
// import '../styles/style.scss'

Vue.use(Element)
